import type {
  RegionalHighlightPurchaseDurationMonths,
  RegionalHighlightPurchaseOption,
} from '@/types/regionalHighlight';

import { regionalHighlightPurchaseDistrictLabel } from './regionalHighlightPurchaseDistrictLabel';

type PurchaseModalTranslate = (
  key:
    | 'regionalHighlight.purchaseModal.regionPriceSuffix'
    | 'regionalHighlight.purchaseModal.positionsFree',
  values: Record<string, string | number>,
) => string;

export const regionalHighlightPurchasePositionsFreeLabel = (
  option: Pick<RegionalHighlightPurchaseOption, 'positionsFree' | 'positionsTotal'>,
  t: PurchaseModalTranslate,
): string =>
  t('regionalHighlight.purchaseModal.positionsFree', {
    free: option.positionsFree,
    total: option.positionsTotal,
  });

export const regionalHighlightPurchaseRegionOptionLabel = (
  option: RegionalHighlightPurchaseOption,
  {
    locale,
    durationMonths,
    includePositionsInLabel,
    t,
    formatFrancsFromChfCents,
  }: {
    locale: string;
    durationMonths: RegionalHighlightPurchaseDurationMonths;
    includePositionsInLabel: boolean;
    t: PurchaseModalTranslate;
    formatFrancsFromChfCents: (cents: number, locale: string) => string;
  },
): string => {
  const monthlyCents = option.monthlyPriceByDuration[durationMonths];
  const districtLabel = regionalHighlightPurchaseDistrictLabel(option, locale);
  const priceSuffix =
    monthlyCents != null
      ? t('regionalHighlight.purchaseModal.regionPriceSuffix', {
          price: formatFrancsFromChfCents(monthlyCents, locale),
        })
      : '';
  const positionsSuffix = includePositionsInLabel
    ? ` (${regionalHighlightPurchasePositionsFreeLabel(option, t)})`
    : '';
  return `${districtLabel}${priceSuffix}${positionsSuffix}`;
};
